import { useDispatch, useSelector } from 'react-redux';
import { kanbanCardsSelector, kanbanDraggingCardSelector } from '../../redux/selectors/kanban';
import { moveKanbanCard, setKanbanDraggingCard } from '../../redux/actions/kanban';

export const useKanbanCard = (card: string) => {
    const dispatch = useDispatch();
    const cards = useSelector(kanbanCardsSelector);
    const draggingCard = useSelector(kanbanDraggingCardSelector);

    const moveCard = (targetId: string, replaceId: string, bottom: boolean) => {
        dispatch(moveKanbanCard(targetId, replaceId, bottom));
    };

    const setDragging = (dragging: boolean) => {
        dispatch(setKanbanDraggingCard(card, dragging));
    };

    return {
        cards,
        dragging: draggingCard === card,
        moveCard,
        setDragging,
    };
};
